export default [
  {
    path: '/meal-counts',
    name: 'MealCounts',
    component: () => import('../pages/MealCountPage.vue'),
    meta: {
      requiresAuth: true,
      title: 'Meal Counts',
        roles: ['sponsor', 'site_representative']
    }
  }
];
